import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: "David Farnandes",
      position: "CEO at Anaton",
      text: "Objectively visualize error-free technology for B2B alignment. Monotonectally harness an expanded array of models via effective collaboration. Globally synergize resource sucking value via cutting-edge.",
      avatar: "/api/placeholder/80/80"
    },
    {
      name: "Jackline Techie",
      position: "CEO at Kormola", 
      text: "Objectively visualize error-free technology for B2B alignment. Monotonectally harness an expanded array of models via effective collaboration. Globally synergize resource sucking value via cutting-edge.",
      avatar: "/api/placeholder/80/80"
    },
    {
      name: "Abraham Khalil",
      position: "CEO at Anatora",
      text: "Objectively visualize error-free technology for B2B alignment. Monotonectally harness an expanded array of models via effective collaboration. Globally synergize resource sucking value via cutting-edge.",
      avatar: "/api/placeholder/80/80"
    },
    {
      name: "Md Sumon Mia", 
      position: "CEO at Rimasu",
      text: "Objectively visualize error-free technology for B2B alignment. Monotonectally harness an expanded array of models via effective collaboration. Globally synergize resource sucking value via cutting-edge.",
      avatar: "/api/placeholder/80/80"
    }
  ];

  return (
    <section className="testimonials section" id="testimonials">
      <div className="container">
        <div className="section-header text-center">
          <p className="testimonials-label">TESTIMONIALS</p>
          <h2>Codes AI CUSTOMER FEEDBACK</h2>
          <h3>What Happy Clients Says About Us?</h3>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card" data-aos="fade-up" data-aos-delay={index * 200}>
              <div className="testimonial-content">
                <div className="quote-icon">
                  <i className="fas fa-quote-left"></i>
                </div>
                <p>"{testimonial.text}"</p>
              </div>
              <div className="testimonial-author">
                <div className="author-avatar">
                  <i className="fas fa-user"></i>
                </div>
                <div className="author-info">
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 